const arweave = require('./arweave')

let API = {
  arweave: arweave.default
}

export default API



// WEBPACK FOOTER //
// ./src/api/api.js